import { render, staticRenderFns } from "./LeaveDayDetail.vue?vue&type=template&id=35cdb8be&scoped=true&"
import script from "./LeaveDayDetail.vue?vue&type=script&lang=js&"
export * from "./LeaveDayDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cdb8be",
  null
  
)

export default component.exports